import React from 'react';

import { Signature as StyledSignature } from './FormSignature.styles.js';

import SignatureCanvas from 'react-signature-canvas'

import './index.scss';
import Loading from '../../components/Loading/Loading.js';

function FormSignature({
	clear,
	loading,
	save,
	undo,
	getCanvasRef,
	textCanvasRef,
	canvasOptions,
	signatureOptions,
	onChangeSignatureType,
	onChangeSignatureText,
	handleKeyDown
}) {
	const isTextSignature = signatureOptions.signature_type === 'TEXT';

	return (
		<StyledSignature className="doca">
			<StyledSignature.Container>
				<p className="doca-text--medium doca-text--large">
					Assine abaixo para validar o formulário
				</p>

				<StyledSignature.SignaturePad>
					<div hidden={!loading}>
						<Loading></Loading>
					</div>

					<div className="doca-button-group">
						<button hidden={loading} className={`text-button ${isTextSignature ? 'doca-button-group--active' : ''}`} onClick={() => onChangeSignatureType('TEXT')} >
							<i className="doca-icon doca-icon__text doca-icon--light doca-icon--large" />
						</button>
						<button hidden={loading} className={`canvas-button ${isTextSignature ? '' : 'doca-button-group--active'}`} onClick={() => onChangeSignatureType('CANVAS')} >
							<i className="doca-icon doca-icon__pen-field doca-icon--light doca-icon--large" />
						</button>
					</div>

					<div hidden={loading || signatureOptions.signature_type !== 'CANVAS'}>
						<SignatureCanvas
							ref={getCanvasRef}
							canvasProps={canvasOptions}
						/>
					</div>

					<div hidden={loading || signatureOptions.signature_type !== 'TEXT'}>
						<canvas hidden={true} width={canvasOptions.width} height={canvasOptions.height} ref={textCanvasRef}></canvas>

						<StyledSignature.SignaturePad.InputContainer>
							<StyledSignature.SignaturePad.TextArea width={canvasOptions.width} value={signatureOptions.signature_text} maxLength={60} onChange={onChangeSignatureText} onKeyDown={handleKeyDown} placeholder='Digite aqui'/>
						</StyledSignature.SignaturePad.InputContainer>
					</div>

					<StyledSignature.Actions hidden={loading} className="doca-mt-2">
						<button className="doca-button doca-button--secondary doca-mr-2" onClick={clear}>
							<i className="doca-icon doca-icon__trash" />

							Limpar
						</button>

						{signatureOptions.signature_type === 'CANVAS' && (
							<button className="doca-button doca-button--secondary" onClick={undo}>
								<i className="doca-icon doca-icon__undo" />

								Desfazer
							</button>
						)}
					</StyledSignature.Actions>
				</StyledSignature.SignaturePad>

				<button disabled={loading}  className="doca-button doca-button--block doca-button--primary doca-mt-6" onClick={save}>
					Salvar assinatura
				</button>
			</StyledSignature.Container>
		</StyledSignature>
	);
}

export default FormSignature;
